import { render, staticRenderFns } from "./GuarantorshipRequests.vue?vue&type=template&id=c26ba0b8&"
import script from "./GuarantorshipRequests.vue?vue&type=script&lang=js&"
export * from "./GuarantorshipRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports